/***
 * 公用常量配置
 */

const platformList = [
	{ label: "淘宝", value: 1 },
	{ label: "京东", value: 2 },
	{ label: "抖音", value: 5 },
	{ label: "微信", value: 4 },
	{ label: "快手", value: 6 },
	{ label: "小红书", value: 3 },
	{ label: "唯品会", value: 8 },
	{ label: "有赞", value: 9 },
]

export default {
	install(Vue) {
		// 活动类型
		Vue.prototype.$platformList = platformList
		// 根据活动类型获取活动类型名称
		Vue.prototype.$getPlatformNameByValue = (value) => {
			const index = platformList.findIndex(item => item.value == value)
			if (index != -1) {
				return platformList[index].label
			} else {
				return ''
			}
		}
	}
}
